var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',_vm._b({attrs:{"type":_vm.type},on:{"click":function($event){return _vm.submit()}}},'el-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }